"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _times = _interopRequireDefault(require("lodash/times"));
var _react = _interopRequireDefault(require("react"));
var _chevronLeft = _interopRequireDefault(require("@spothero/icons/chevron-left"));
var _chevronRight = _interopRequireDefault(require("@spothero/icons/chevron-right"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _Select = _interopRequireDefault(require("../../../Select/Select"));
const TableControls = ({
  currentPage,
  totalPages,
  onPageChange,
  onPreviousPage,
  onNextPage
}) => {
  const pages = (0, _times.default)(totalPages, value => {
    const page = (value + 1).toString();
    return {
      label: `Page ${page}`,
      value: page
    };
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "TableControls"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "TableControls-pagination"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    color: "secondary",
    disabled: currentPage === 1,
    onClick: onPreviousPage
  }, /*#__PURE__*/_react.default.createElement(_chevronLeft.default, null)), /*#__PURE__*/_react.default.createElement(_Select.default, {
    key: new Date(),
    defaultValue: currentPage.toString(),
    items: pages,
    onChange: onPageChange
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    color: "secondary",
    disabled: currentPage === totalPages,
    onClick: onNextPage
  }, /*#__PURE__*/_react.default.createElement(_chevronRight.default, null))));
};
var _default = exports.default = TableControls;